import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CopyrightIcon from '@material-ui/icons/Copyright';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      zIndex: '4',
      height: '32px',
    },
  })
);

export default function Footer() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  let Year = new Date().getFullYear() + "";

  return (
    <div className="container-fluid p-0">
      <Box className="bg-dark text-white fs90">
        <div className="py-3 py-md-5">
          <img src="/images/da002-footer.png" className="img-fluid" />
        </div>
        <div className="container px-3">
          <div className="d-flex flex-wrap justify-content-start align-items-start px-3">
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">会社案内</Typography>
                <ul>
                  <li><a href="/guide-overview">会社概要</a></li>
                  <li><a href="https://recruit.daily-tohoku.company/" target="_blank">採用情報</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/about-delion" target="_blank">公式キャラクター</a></li>
                  <li><a href="/award">デーリー東北賞</a></li>
                  <li><a href="/award-delion">デリオン賞</a></li>
                  <li><a href="https://www.tohokuno-design.com/" target="_blank">東北のデザイン社</a></li>
                  <li><a href="https://stores.jtb.co.jp/bp289-0" target="_blank">デーリー東北たびーぐ</a></li>
                  <li><a href="https://www.nanbukaikan.com/" target="_blank">南部会館</a></li>
                  <li><a href="http://feature.daily-tohoku.co.jp/web2/company/company-cafe.html" target="_blank">しんぶんカフェ</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">サービス</Typography>
                <ul>
                  <li><a href="/guide-service">NIE</a></li>
                  <li><a href="/support">後援願い</a></li>
                  <li><a href="/tour">会社見学</a></li>
                  <li><a href="/printservice">掲載写真販売</a></li>
                  <li><a href="https://form.daily-tohoku.org/" target="_blank">バックナンバー販売</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">購読のご案内</Typography>
                <ul>
                  <li><a href="/guide-shop#koudoku">ご購読はこちら</a></li>
                  <li><a href="/guide-shop#shidoku">ご試読はこちら</a></li>
                  <li><a href="https://www.daily-tohoku.news/user-guide" target="_blank">デジタル新規会員</a></li>
                  {/* <li><a href="https://www.q-delisunday.com/daily-hanbai201904-2-2-2-2-2-2-2-2-2-2-2-2-2-2-2-2-2-3-2-2-2-2-2-3-2-2-2-2-2-2-2-2-2-2-2/" target="_blank">配達員募集</a></li> */}
                  <li><a href="/guide-shop#shop-list">販売店一覧</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">広告・折込のご案内</Typography>
                <ul>
                  <li><a href="/advertisement">新聞広告</a></li>
                  <li><a href="/flyer">折込広告（チラシ）</a></li>
                  <li><a href="/guide-advertisement#ad-kyu-deli">求ーでり</a></li>
                  <li><a href="https://www.47club.jp/?cid=vc" target="_blank">47CLUB</a></li>
                  <li><a href="/guide-advertisement#ad-kanaeru">カナエルはちのへ</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">投稿応募</Typography>
                <ul>
                  <li><a href="/guide-wanted/#about-post">投稿応募について</a></li>
                  <li><a href="https://form.daily-tohoku.org/idol">うちのアイドル</a></li>
                  <li><a href="https://form.daily-tohoku.org/pet">マイパートナー</a></li>
                  <li><a href="/guide-wanted#post-kodama">こだま</a></li>
                  <li><a href="https://form.daily-tohoku.org/photo">フォト</a></li>
                  <li><a href="http://daily-tohoku.com/youngpost/">ヤングポスト</a></li>
                  <li><a href="https://form.daily-tohoku.org/fishing">釣果じまん</a></li>
                  <li><a href="https://form.daily-tohoku.org/daily-voice">デーリーボイス</a></li>
                </ul>
              </div>
            </div>
          </div>

          <hr className="footer-divider my-3" />

          <div className="d-flex flex-wrap justify-content-start align-items-start px-3">
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">主催事業</Typography>
                <ul>
                  <li><a href="https://event-guide.daily-tohoku.news/real-experience">リアル体験事業</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/umineko-marathon">うみねこマラソン</a></li>
                  {/* <li><a href="/guide-business#event_2">八戸リレーマラソン</a></li> */}
                  <li><a href="https://event-guide.daily-tohoku.news/biblio">ビブリオバトル</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/childpainting">こども絵画コンクール</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/archives/event/%e6%b0%91%e8%ac%a1%e3%83%bb%e3%81%8a%e7%ac%91%e3%81%84%e5%a4%a2%e3%81%ae%e7%a5%ad%e5%85%b8">民謡夢の祭典</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/archives/event/%e5%8c%97%e5%a5%a5%e7%be%bd%e5%9b%b2%e7%a2%81%e5%90%8d%e4%ba%ba%e6%88%a6">北奥羽囲碁名人戦</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/archives/event/%e5%8c%97%e5%a5%a5%e7%be%bd%e5%9b%a3%e4%bd%93%e5%9b%b2%e7%a2%81%e5%a4%a7%e4%bc%9a">北奥羽団体囲碁大会</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/manabi-park">夏休み学びパーク</a></li>
                  <li><a href="https://www.recruit-lounge.com/">リクルートラウンジ</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/newspaper-report">新聞感想文コンクール</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/mytensho">私の天鐘コンクール</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/#sec-event">その他の事業一覧</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">チケット情報</Typography>
                <ul>
                  <li><a href="https://event-guide.daily-tohoku.news/#sec-ticket">取り扱いチケット</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/#sec-ticket-faq">よくある質問</a></li>
                </ul>
              </div>
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">ホール貸し出し</Typography>
                <ul>
                  <li><a href="/hall#hall-1f">デーリー東北ホール</a></li>
                  <li><a href="/hall#hall-6f">メディアホール</a></li>
                  <li><a href="/hall#hall-price">ホール使用料金</a></li>
                  <li><a href="/hall#hall-entry">貸館申し込みについて</a></li>
                  <li><a href="/hall#hall-caution">諸注意</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">デリオンくらぶ</Typography>
                <ul>
                  <li><a href="https://delion-dt.com/">デリオンくらぶとは</a></li>
                  <li><a href="https://event-guide.daily-tohoku.news/about-delion">デリオンとは</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">政経懇話会</Typography>
                <ul>
                  <li><a href="/forum#forum-about">例会</a></li>
                  <li><a href="/forum#forum-special">特典</a></li>
                  <li><a href="/forum#forum-entry">入会のご案内</a></li>
                  <li><a href="/forum/history">過去の例会</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-menu-item-wrap">
              <div className="footer-menu-item">
                <Typography className="text-left my-3" variant="subtitle1" component="h2">お問い合わせ</Typography>
                <ul>
                  <li><a href="/contactus#cu-newspaper">紙面・記事について</a></li>
                  <li><a href="/contactus#cu-hall">ホール貸館について</a></li>
                  <li><a href="/contactus#cu-ticket">チケットについて</a></li>
                  <li><a href="/contactus#cu-book">デーリー東北の書籍</a></li>
                  <li><a href="/contactus#cu-web">ウェブサイトについて</a></li>
                  <li><a href="/contactus#cu-digital">デーリー東北デジタルについて</a></li>
                  <li><a href="/daily-right">著作権について</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="py-3">
            <hr className="footer-divider" />
            &copy; {Year} THE DAILY TOHOKU SHIMBUN.
          </div>

        </div>

      </Box>
    </div>
  );
}
